import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import ClientTestimonials from '../components/ClientTestimonials';
import Problem from '../components/Problem';
import BrandTheme from '../components/BrandTheme';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import WhoItsFor from '../components/WhoItsFor';
import Results from '../components/Results';
import LimitedCapacity from '../components/LimitedCapacity';
import PackagesTeaser from '../components/PackagesTeaser';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';

const HomePage = () => {
  return (
    <div className="home-page">
      <SEO 
        title="FractionalVA - Executive Operations, Redefined" 
        description="Reclaim your time and amplify your impact. FractionalVA provides elite virtual assistant services for busy leaders. Stop wasting moves, start making progress." 
        name="FractionalVA"
        type="website"
      />
      <Hero />
      <ClientTestimonials />
      <Problem />
      <BrandTheme />
      <Services />
      <HowItWorks />
      <WhoItsFor />
      <Results />
      <LimitedCapacity />
      <PackagesTeaser />
      <FAQ />
      <FinalCTA />
    </div>
  );
};

export default HomePage;